import React, { useState } from "react";
import { RootState } from "../../store";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../components/ui/Header";
import Footer from "../../components/layout/Footer";
import GridSection from "../../components/ui/sections/GridSection";
import NotFoundList from "../../components/ui/NotFoundList";
import { clearHistory } from "../../store/slices/postSlice";

export const TABS = [
  { label: "Phim", type: "movie" },
  { label: "Truyện", type: "comic" },
  { label: "Game", type: "game" },
];

const HistoryContentsPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState("movie");
  const [isSelect, setIsSelect] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]); // State lưu id phim đã chọn
  const viewedHistory = useSelector(
    (state: RootState) => state.post.viewedHistory
  );
  const dispatch = useDispatch();

  const filteredHistory = viewedHistory.filter(
    (item: any) => item.posttype === selectedTab
  );

  // Hàm xử lý chọn/bỏ chọn phim
  const handleSelectMovie = (id: string) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // Xoá các mục đã chọn khỏi lịch sử
  const handleDeleteSelected = () => {
    if (selectedIds.length === 0) return;
    // Nếu muốn cập nhật redux, nên tạo action removeMultiFromHistory
    // Tạm thời chỉ cập nhật local (ẩn các mục đã chọn khỏi giao diện)
    // Nếu muốn cập nhật redux thực sự, cần thêm action vào postSlice
    // setViewedHistory(viewedHistory.filter(item => !selectedIds.includes(String(item.id))));
    setSelectedIds([]);
    setIsSelect(false);
  };

  // Huỷ chọn
  const handleCancelSelect = () => {
    setIsSelect(false);
    setSelectedIds([]);
  };

  const renderTab = () => {
    return (
      <div className="flex justify-center mt-4 mb-6 gap-4">
        {TABS.map((tab) => (
          <button
            key={tab.type}
            className={`px-10 py-2   font-semibold   ${
              selectedTab === tab.type
                ? "border-primary border-b-4 text-white"
                : " text-gray-300 hover:bg-primary"
            }`}
            onClick={() => {
              setSelectedTab(tab.type);
              setSelectedIds([]); // Reset chọn khi đổi tab
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  };
  const renderSelect = () => {
    return (
      <button
        className="bg-primary text-white px-4 text-sm py-2 rounded-md"
        onClick={() => {
          setIsSelect((prev) => {
            if (prev) setSelectedIds([]); // Reset chọn khi tắt chế độ chọn
            return !prev;
          });
        }}
      >
        {isSelect ? "Huỷ" : "Chọn"}
      </button>
    );
  };

  // Thanh action khi chọn
  const renderSelectActions = () => {
    return (
     <div className="flex gap-2 px-4 justify-end items-center  bg-transparent  sticky top-0 z-20">

        <button
          className="bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded disabled:opacity-50"
          disabled={selectedIds.length === 0}
          onClick={handleDeleteSelected}
        >
          Xoá ({selectedIds.length})
        </button>
        <button
          className="bg-red-700 hover:bg-red-800 text-white px-4 py-1 rounded"
          onClick={() => { dispatch(clearHistory()); handleCancelSelect(); }}
        >
          Xoá toàn bộ
        </button>
        <button
          className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-1 rounded"
          onClick={handleCancelSelect}
        >
          Huỷ
        </button>
      </div>
    );
  };

  return (
    <div className="bg-mainBlack text-white min-h-screen flex flex-col">
      <Header
        renderBottomNav={renderTab()}
        renderFilter={filteredHistory?.length > 0 && renderSelect()}
      />
      {isSelect && renderSelectActions()}
      {/* Tabs */}

      {filteredHistory.length > 0 ? (
        <GridSection
          movies={filteredHistory}
          isSelectMode={isSelect}
          selectedIds={selectedIds}
          onSelectMovie={handleSelectMovie}
        />
      ) : (
        <NotFoundList
          title="Chưa có thông tin nào"
          description={`Nhấn vào button bên dưới\nđể nhanh chóng \ntruy cập lại những ${TABS.find(
            (t) => t.type === selectedTab
          )?.label.toLowerCase()} yêu thích của bạn!`}
        />
      )}
      <Footer />
    </div>
  );
};

export default HistoryContentsPage;
